import { Col, Row, Spin, Icon } from 'antd';
import React from 'react';
import { CSVLink } from 'react-csv';
import { SORT_ITEM_BY } from '../../../../../constants';
import deteleConfirmDialog from '../deteleConfirmDialog';
import Filter from '../filter';
import HeaderItemName from '../header-item-name';
import ImportPanel from '../import-panel';
import Rows from '../rows';
import lang from './../../../../../languages/en';
import { alertError, alertSuccess, confirmChangeItem, showConfirm } from './../../../../../services/dialog';
import handleException from './../../../../../services/handleException';
import { dateTimeCurrent } from './../../../../../services/helper';
import { deleteDatabase, deleteItem, exportItemName } from './../../../../../utils/settingMerchant';
import ToolbarItemMaster from './ToolbarItemMaster';
import { ListChannel } from './../../../../../constants/setting_channel';
import history from './../../../../../services/history';
import './styles.css';
import { convertDateFromUTC } from './../../../../../services/dst';

const initialFilterState = {
    sku: '',
    itemCode: '',
    itemNameEn: '',
    itemNameJp: '',
    countryOfOrigin: '',
    OrderBy: SORT_ITEM_BY.CreatedDT_DESC,
}

class MasterMaintenance extends React.Component {
    newRowCount = 0
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            checkedAll: false,
            collectIdItem: [],
            collectIdItemCurrent: [],
            fileName: null,
            itemNameData: [],
            channelActive: null,
            isFilterVisible: false,
            isImportVisible: false,
            disableDeleteDatabase: true,
            checkChangeOnce: true,
            isEdit: false,
            checkErrorInput: false,
            dataImport: {
                countCreate: 0,
                countDelete: 0,
                countEdit: 0
            },
            pagination: {
                countItemName: 0,
                currentPage: 1,
                pageSize: 20,
                pageCount: 0
            },
            filterValues: {
                ...initialFilterState
            },
            LineNumberHasProhibited: null,
            DefaultWeightUnitCH: null,
            LineNumberItemname: null
        }
    }

    onchangeLineNumberHasProhibited = (number) => {
        this.setState({
            LineNumberHasProhibited: number
        })
    }

    onchangeLineNumberItemName = (number) => {
        this.setState({
            LineNumberItemname: number
        })
    }

    onchangeDefaultWeightUnitCH = (value) => {
        this.setState({
            DefaultWeightUnitCH: value
        })
    }

    componentDidMount() {
        document.getElementById('setting-merchant').className += " list-item";
    }

    componentWillUnmount() {
        document.getElementById('setting-merchant').classList.remove("list-item");
    }

    checkButtonDelete = () => {
        if (this.state.collectIdItem.length) {
            return false
        }
        return true;
    }

    handleLoading = (value) => {
        return this.setState({
            isLoading: value
        })
    }

    resetCheckbox = () => {
        this.setState({
            collectIdItem: [],
            checkedAll: false
        })
    }

    checkedAll = (value) => {
        let { collectIdItem, collectIdItemCurrent } = this.state
        collectIdItemCurrent.map((e, i) => {
            let index = collectIdItem.indexOf(e)
            if (index === -1 && value) {
                collectIdItem.push(e)
            }
            if (!value && index !== -1) {
                collectIdItem.splice(index, 1)
            }
            return false;
        })
        this.setState({
            collectIdItem,
            checkedAll: value
        })
    }

    collectIdItem = (value) => {
        this.setState({
            collectIdItem: value
        }, () => {
            let checkedAll = true
            if (!this.state.collectIdItemCurrent.length) return;
            this.state.collectIdItemCurrent.map((e, i) => {
                if (this.state.collectIdItem.indexOf(e) === -1) {
                    checkedAll = false
                }
                return false;
            })
            this.setState({
                checkedAll
            })
        })
    }

    inforPagination = (pagination) => {
        this.setState({
            pagination
        })
    }

    handlePagination = (currentPage) => {
        const { pagination: { pageSize }, channelActive, filterValues, sortParams } = this.state
        return new Promise((resolve, reject) => {
            this.setState({
                pagination: {
                    ...this.state.pagination,
                    currentPage
                }
            }, async () => {
                await this.loadData(currentPage, pageSize, channelActive, filterValues, sortParams)
                resolve('done')
            })
        })
    }

    changePagination = (currentPage, size) => {
        if (this.state.checkErrorInput) {
            return alertError(lang.field_some_required)
        }
        if (this.state.isEdit) {
            confirmChangeItem(lang.confirm_save_item_name,
                () => {
                    let data = {
                        type: 'saveChangePaginate',
                        currentPage,
                        size
                    }
                    this.refRows.saveItemName(data)
                },
                () => {
                    const { filterValues, pagination, channelActive } = this.state
                    this.loadData(currentPage, pagination.pageSize, channelActive, filterValues)
                })
        } else {
            this.handlePagination(currentPage)
        }
    }

    checkAllWhenActivePagination = () => {
        const { collectIdItemCurrent, collectIdItem } = this.state
        let checkAll = true

        if (!collectIdItemCurrent.length) return;
        collectIdItemCurrent.map(e => {
            if (collectIdItem.indexOf(e) === -1) {
                checkAll = false
            }
            return false;
        })
        this.setState({
            checkedAll: checkAll
        })
    }

    loadData = (currentPage, pageSize, channelActive, filterValues, sortParams) => {
        this.refRows.loadData(currentPage, pageSize, channelActive, filterValues, sortParams)
    }

    deleteItemName = () => {
        if (this.state.isEdit) {
            this.popUpConfirmSave(null, null,
                () => showConfirm(lang.confirm_delete_item_name, () => this.handleDeleteItemName()),
                () => showConfirm(lang.confirm_delete_item_name, () => this.handleDeleteItemName()))
        } else {
            showConfirm(lang.confirm_delete_item_name, () => this.handleDeleteItemName())
        }
    }

    handleDeleteItemName = () => {
        let { pagination, channelActive, filterValues, sortParams } = this.state
        let { collectIdItemCurrent, collectIdItem } = this.state

        let checkItemChecked = this.refRows.checkItemCheckedInList()
        if (!checkItemChecked) {
            if (!collectIdItemCurrent.length && pagination.pageCount > 1) {
                pagination.currentPage--
            }
            this.setState({
                checkedAll: false,
                pagination
            }, () => {
                this.refRows.loadData(pagination.currentPage, pagination.pageSize, channelActive, filterValues)
                this.refRows.checkErrorInput()
            })
            return;
        }
        this.handleLoading(true)
        deleteItem(collectIdItem).then(res => {
            if (res.data.code === 10001) {
                if (JSON.stringify(collectIdItemCurrent) === JSON.stringify(collectIdItem) && pagination.currentPage > 1) {
                    pagination.currentPage -= 1
                }
                alertSuccess(lang.item_delete_success)
                collectIdItem = []
            } else {
                handleException(res)
            }
            this.handleLoading(false)
            this.refRows.loadData(pagination.currentPage, pagination.pageSize, channelActive, filterValues, sortParams)
            this.setState({
                checkedAll: false,
                collectIdItem,
                pagination: {
                    ...this.state.pagination,
                    currentPage: 1
                }
            }, () => {
                this.refRows.checkErrorInput()
            })
        }).catch(err => {
            this.handleLoading(false)
            handleException(err)
        })
    }

    onChoiceFile = e => {
        if (!(/\.(csv)$/i).test(e.target.files[0].name)) {
            alertError('Invalid file type.', 'Please select a CSV file and try again.')
        } else {
            this.setState({
                fileName: e.target.files[0]
            })
        }
    }

    browseFile = () => {
        document.getElementById('f02').click()
    }

    exportFile = () => {
        this.handleLoading(true)
        exportItemName(this.state.channelActive).then(res => {
            this.setState({
                itemNameData: res.data,
            }, () => {
                document.getElementById('export-item-name').click()
            })
            this.handleLoading(false)
        }).catch(error => {
            this.handleLoading(false)
            handleException(error)
        })
    }

    importFile = () => {
        if (this.state.checkErrorInput) {
            return alertError(lang.field_some_required)
        }
        if (this.state.isEdit) {
            this.popUpConfirmSave(null, null,
                () => this.handleImportFile(),
                () => this.handleImportFile())
        } else {
            this.handleImportFile()
        }
    }

    handleImportFile = () => {
        this.refImportPanel.visibleStepImportOrder(true)
    }

    collectIdItemCurrent = (value) => {
        this.setState({
            collectIdItemCurrent: value
        }, () => {
            this.checkAllWhenActivePagination()
        })
    }

    selectChannel = (channel_id) => {
        const { sortParams } = this.state
        this.setState({
            channelActive: channel_id,
            filterValues: {
                ...initialFilterState
            }
        })
        this.refRows.loadData(1, this.state.pagination.pageSize, channel_id, sortParams)
    }

    shortChannel = (shortChannel) => {
        this.setState({
            shortChannel
        })
        for (let key in ListChannel) {
            let itemChannel = ListChannel[key];
            if (shortChannel == itemChannel.ShortName) {
                this.setState({
                    fileNameExportItemMaster: itemChannel.NameFileExportItemMaster
                })
                break;
            }
        }
    }

    onProhibitedItems = () => {
        if (this.state.checkErrorInput) {
            return alertError(lang.field_some_required)
        }
        if (this.state.isEdit) {
            this.popUpConfirmSave(null, null,
                () => history.push(`/setting/merchant/prohibited/${this.state.channelActive}`),
                () => history.push(`/setting/merchant/prohibited/${this.state.channelActive}`))
        } else {
            history.push(`/setting/merchant/prohibited/${this.state.channelActive}`)
        }
    }

    onChangePageSize = (e) => {
        if (this.state.checkErrorInput) {
            return alertError(lang.field_some_required)
        }
        if (this.state.isEdit) {
            this.popUpConfirmSave(null, null,
                () => this.handleOnChangePageSize(e),
                () => this.handleOnChangePageSize(e))
        } else {
            this.handleOnChangePageSize(e)
        }
    }

    handleOnChangePageSize = (e) => {
        const { filterValues, sortParams } = this.state

        this.setState({
            pagination: {
                ...this.state.pagination,
                pageSize: e
            }
        })

        this.loadData(this.state.pagination.currentPage, e, this.state.channelActive, filterValues, sortParams)
    }

    toggleFilter = () => {
        this.setState({
            isFilterVisible: !this.state.isFilterVisible
        })
    }

    onResetFilter = () => {
        const { channelActive, pagination: { pageSize, currentPage }, sortParams } = this.state
        // clear filter input
        this.setState({
            filterValues: {
                ...initialFilterState
            }
        })
        //reload list
        this.loadData(currentPage, pageSize, channelActive, sortParams)
    }

    onFilterChange = e => {
        this.setState({
            filterValues: {
                ...this.state.filterValues,
                [e.target.name]: e.target.value
            }
        })
    }

    onApplyFilter = () => {
        const { channelActive, filterValues, pagination: { pageSize, currentPage } } = this.state
        if (this.state.isEdit) {
            confirmChangeItem(lang.confirm_save_item_name,
                () => {
                    let data = {
                        currentPage,
                        pageSize,
                        channelActive,
                        filterValues,
                        type: "applyFilter"
                    }
                    this.refRows.saveItemName(data)
                }, () => this.loadData(currentPage, pageSize, channelActive, filterValues))
        } else {
            this.loadData(currentPage, pageSize, channelActive, filterValues)
        }
    }

    deleteDatabase = () => {
        const { channelActive } = this.state

        deteleConfirmDialog(() => {
            this.handleLoading(true)
            deleteDatabase(channelActive).then(res => {
                this.handleLoading(false)
                this.selectChannel(channelActive)
                this.refRows.checkErrorInput()
                alertSuccess(lang.database_deleted_successfully)
            }).catch(err => {
                handleException(err)
                this.handleLoading(false)
            })
        })
    }

    addNewRow = () => {
        if (this.state.isEdit) {
            this.popUpConfirmSave(false, { isAddedLoad: true }).then(res => {
                this.handleAddNewRow()
            })
        } else {
            this.handleAddNewRow()
        }
    }

    handleAddNewRow = () => {
        const { pageCount, currentPage } = this.state.pagination
        if (currentPage < pageCount) {
            this.refRows.asyncAddNewRow();
        } else {
            this.refRows.addNewRow();
        }
    }

    saveItemName = () => {
        this.refRows.saveItemName()
    }

    isEditItemFuns = (name, value) => {
        this.setState({
            [name]: value
        })
        this.props.isEditItemFuns(name, value)
    }

    popUpConfirmSave = (loadData = false, typeSave = null, callback, cancel) => {
        return new Promise((rs, rj) => {
            confirmChangeItem(lang.confirm_save_item_name, () => {
                this.refRows.saveItemName(typeSave, !loadData, callback)
                rs('done')
            }, () => {
                const { pagination, channelActive } = this.state
                loadData && this.loadData(pagination.currentPage, pagination.pageSize, channelActive)
                cancel && typeof cancel === 'function' && cancel()
                rs('done')
            })
        })
    }

    checkErrorInput = (value) => {
        this.setState({
            checkErrorInput: value
        })
        this.props.checkErrorInput(value)
    }
    renderListProhibitedItems = () => {
        let items = this.props.prohibitedItems;
        if (items && items.length > 0) {
            let length = items.length;
            let arrProhibite = [];
            items.map((value, key) => {
                arrProhibite.push(value.ProhibitedKeyword)
            })
            return `The following words have recently been added to the prohibited items keyword list: ${arrProhibite.join(', ')}.` 
        } else {
            return `Please click the "Prohibited Item Keyword Check" icon to review your items that may contain prohibited keywords.`
        }
    }

    handleOnclickCloseWarning = () => {
        let payload = {
            statusDisplay: false,
            lastestUpdateDTOrigin: this.props.lastestUpdateDTOrigin
        }
        this.props.onChangeDisplayNewUpdateProhibited(payload)
    }

    render() {
        return (
            <React.Fragment>
                <Spin spinning={this.state.isLoading} tip='Loading...'>
                    <CSVLink
                        id="export-item-name"
                        data={this.state.itemNameData}
                        target={"_self"}
                        filename={this.state.fileNameExportItemMaster + '_ItemMaster_' + dateTimeCurrent() + '.csv'}
                    />
                    <ImportPanel
                        channelActive={this.state.channelActive}
                        ref={ref => this.refImportPanel = ref}
                        selectChannel={this.selectChannel}
                    />
                    <Row id="maintenacne-content">
                        <Col span={24}>
                            { this.props.displayNewUpdateProhibited ? 
                                <div className="box-alert-new-update-prohibited">
                                    <span className="box-warring">
                                        <Icon type="exclamation" className="icon-warning warning" />
                                    </span>
                                    <p className="title-warning">
                                        <div className="content-tile-warning">
                                            {convertDateFromUTC(this.props.lastUpdateProhibited).format("MM/DD/YYYY")}: {this.renderListProhibitedItems()}
                                        </div>
                                    </p>
                                    <a className="icon-close-warning" onClick={this.handleOnclickCloseWarning} ><Icon type="close" ></Icon></a>
                                </div>
                                : ''
                            } 
                        </Col>
                        <Col id="setting-content" className="left-col" span={24}>
                            <div className="table-header">
                                <ToolbarItemMaster
                                    checkButtonDelete={this.checkButtonDelete}
                                    saveItemName={this.saveItemName}
                                    onProhibitedItems={this.onProhibitedItems}
                                    selectChannel={this.selectChannel}
                                    resetCheckbox={this.resetCheckbox}
                                    importFile={this.importFile}
                                    addNewRow={this.addNewRow}
                                    deleteItemName={this.deleteItemName}
                                    toggleFilter={this.toggleFilter}
                                    exportFile={this.exportFile}
                                    deleteDatabase={this.deleteDatabase}
                                    changePagination={this.changePagination}
                                    onChangePageSize={this.onChangePageSize}
                                    shortChannel={this.shortChannel}
                                    popUpConfirmSave={this.popUpConfirmSave}
                                    isFilterVisible={this.state.isFilterVisible}
                                    pagination={this.state.pagination}
                                    channelActive={this.state.channelActive}
                                    isEdit={this.state.isEdit}
                                    collectIdItemCurrent={this.state.collectIdItemCurrent}
                                    checkErrorInput={this.state.checkErrorInput}
                                    LineNumberHasProhibited={this.state.LineNumberHasProhibited}
                                    LineNumberItemname={this.state.LineNumberItemname}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Filter
                                filterValues={this.state.filterValues}
                                isFilterVisible={this.state.isFilterVisible}
                                toggleFilter={this.toggleFilter}
                                onResetFilter={this.onResetFilter}
                                onFilterChange={this.onFilterChange}
                                onApplyFilter={this.onApplyFilter}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="right-col" span={24}>
                            <div className="table-operations">
                                <table className='table-merchant-setting'>
                                    <HeaderItemName
                                        sortParams={this.state.sortParams}
                                        checkedAll={this.checkedAll}
                                        valueCheckox={this.state.checkedAll}
                                        idItemName={this.state.collectIdItem}
                                        handleSort={this.handleSort}
                                        collectIdItemCurrent={this.state.collectIdItemCurrent}
                                        DefaultWeightUnitCH={this.state.DefaultWeightUnitCH}
                                    />
                                    <Rows
                                        onchangeLineNumberHasProhibited={this.onchangeLineNumberHasProhibited}
                                        onchangeLineNumberItemName={this.onchangeLineNumberItemName}
                                        onchangeDefaultWeightUnitCH={this.onchangeDefaultWeightUnitCH}
                                        handleLoading={this.handleLoading}
                                        collectIdItem={this.collectIdItem}
                                        ref={e => this.refRows = e}
                                        collectIdItemCurrent={this.collectIdItemCurrent}
                                        inforPagination={this.inforPagination}
                                        isEditItemFuns={this.isEditItemFuns}
                                        handlePagination={this.handlePagination}
                                        checkErrorInput={this.checkErrorInput}
                                        checkedAll={this.checkedAll}
                                        updateEditingRow={this.updateEditingRow}
                                        saveItemName={this.saveItemName}
                                        idItemName={this.state.collectIdItem}
                                        pagination={this.state.pagination}
                                        collectIdItemCurrentValue={this.state.collectIdItemCurrent}
                                        channelActive={this.state.channelActive}
                                        isEdit={this.state.isEdit}
                                        checkChangeOnce={this.state.checkChangeOnce}
                                        filterValues={this.state.filterValues}
                                        currentShortChannel={this.state.shortChannel}
                                    />
                                </table>
                            </div>
                        </Col>
                    </Row>
                </Spin>
            </React.Fragment>
        )
    }
}

export default MasterMaintenance



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/master-maintenance/index.js